export default{
  tabTitle: 'Join the OPPO Meetup and Connect Beyond Screens',
  tabDescription: 'Welcome to the OPPO Meetup, where passionate fans celebrate innovation, share stories, and create unforgettable moments as one vibrant Community.',
  oppoMeetup: 'OPPO Meetup',
  oneplusMeetup: 'OnePlus Offline Events',
  highlightTitle: 'Meetup Highlights | Past Highlights',
  exhibitionTitle: 'The Meetup Story So Far | Explore All Events',
  fanhosts: 'Meet Our Fan Hosts! | Fan Hosts',
  fanhostsDescription: 'A dedicated group of members who bridge the connection between guests and OPPO at our Meetups. They are the backbone of every unforgettable event. | A dedicated group of members who bridge the connection between guests and OPPO at our Meetups. They are the backbone of every unforgettable event. ',
  ugcContent: 'Meetup Showcase | User Stories Spotlight',
  trendingActivities: 'More Activities | Load More Moments',
  moreHighlights: 'See more',
  seemore: 'Learn more | Load More Moments',
  showmore: 'Get to Know Them | Get to Know Them',
  viewDetail: 'View Details'
}